
import { defineComponent, reactive, onMounted, toRefs, computed } from 'vue'
import f10ApiUS from '@/api/f10ApiUS'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import { useRoute } from 'vue-router'
import { isLocalDev } from '@/api/config'

export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => ({})
    },
    token: {
      type: String,
      default: ''
    }
  },
  components: { Table, Nodata },

  setup(props) {
    const route = useRoute()

    const pageData = reactive({
      rawData: [] as any[],
      allData: [] as any[], // 存储所有数据
      filterType: 'all', // 默认选中"过滤不分红"
      columns: [
        {
          title: '公告日',
          dataIndex: 'announceDate',
          key: 'announceDate',
          width: '160px',
          align: 'center'
        },
        {
          title: '分红方案',
          dataIndex: 'planExplain',
          key: 'planExplain',
          width: '240px',
          align: 'center'
        },
        {
          title: '除权日',
          dataIndex: 'exDate',
          key: 'exDate',
          width: '160px',
          align: 'center'
        },
      ],
      // 分页相关
      total: 0,
      pageSize: 10, // 每页显示条数
      currentPage: 1, // 当前页码
      spinning: true
    })

    // 格式化日期
    const formatDate = (timestamp: number | null) => {
      if (!timestamp) return '-'
      return window.moment(timestamp).format('YYYY-MM-DD')

      // const date = new Date(timestamp)
      // return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
    }

    // 格式化报告期
    const formatReportPeriod = (record: any) => {
      const year = new Date(record.reportDate).getFullYear()
      return `${year}${record.reportPeriodType}`
    }

    // 本地分页计算当前页数据
    const pagedData = computed(() => {
      const start = (pageData.currentPage - 1) * pageData.pageSize
      const end = start + pageData.pageSize
      return pageData.allData.slice(start, end)
    })

    // 分页配置
    const pagination = reactive({
      total: 0,
      get current() {
        return pageData.currentPage
      },
      set current(val: number) {
        pageData.currentPage = val
      },
      pageSize: pageData.pageSize,
      showSizeChanger: true,
      showTotal: (total: number) => `共${total}条`,
      pageSizeOptions: ['10', '20', '50', '100'],
      onChange: (page: number, pageSize?: number) => {
        pageData.currentPage = page
        if (pageSize) pageData.pageSize = pageSize
      },
      onShowSizeChange: (current: number, size: number) => {
        pageData.currentPage = 1
        pageData.pageSize = size
      }
    })

    // 处理API数据
    const processApiData = (data: any[]) => {

      return (data || []).map((item: any) => {
        const currencyDisplay = item.currencyName || (item.currencyCode === 'USD' ? '美元' : (item.currencyCode || ''))
        const planExplain = item.dividendPs != null ? `每股${item.dividendPs}${currencyDisplay}` : '-'

        return {
          ...item,
          announceDate: formatDate((item.announcementDate)),
          planExplain,
          exDate: formatDate((item.exRightDate)),
        }
      })
    }



    onMounted(() => {

      const market = isLocalDev ? 'NASDAQ' : (route.query.market as string)
      const symbol = isLocalDev ? 'AAPL' : (route.query.code as string)

      const data = {
        data: {
          market,
          symbol,
        },
        headers: {
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
        }
      }

      f10ApiUS.getFhAndCg(data).then((res: any) => {
        if (res.data && res.data) {
          console.log('getFhAndCg', res.data)
          const list = (res.data && res.data.dividendList) ? res.data.dividendList : res.data
          pageData.rawData = processApiData(list)
          pageData.allData = pageData.rawData

          // 更新分页信息
          pageData.total = pageData.allData.length
          pagination.total = pageData.total
          pagination.current = pageData.currentPage
          pagination.pageSize = pageData.pageSize
        }
        pageData.spinning = false
      }).catch(() => {
        pageData.spinning = false
      })
    })

    return {
      ...toRefs(pageData),
      pagedData,
      pagination
    }
  }
})
